import React, { useState } from "react";

import moment from "moment-timezone";

import { formatTimestampShort } from "utils/format";

import { useUpdateOrganizationSamlCertificateMutation } from "./gql/Mutation.generated";
import Button from "ui/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/pro-solid-svg-icons";
import { useSetFlash } from "providers/WithFlashes";

const UpdateCertSaml = ({
  organizationSlug,
  idpCertExpiresAt,
}: {
  organizationSlug: string;
  idpCertExpiresAt: number | null;
}) => {
  const [expanded, setExpanded] = useState(false);
  const [certValue, setCertValue] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const setFlash = useSetFlash();

  const [updateCert, { loading }] =
    useUpdateOrganizationSamlCertificateMutation();

  const handleSave = () => {
    updateCert({
      variables: {
        organizationSlug,
        idpCert: certValue,
      },
      onCompleted: () => {
        setExpanded(false);
        setCertValue("");
        setErrorMessage("");
        setFlash("success", "SAML certificate updated");
      },
      onError: (error) => {
        setErrorMessage(error.message);
      },
    });
  };

  const handleCancel = () => {
    setExpanded(false);
    setCertValue("");
    setErrorMessage("");
  };

  const expirationInfo = idpCertExpiresAt ? (
    <>
      Current certificate expires on{" "}
      {formatTimestampShort(moment.unix(idpCertExpiresAt))}.
    </>
  ) : null;

  return (
    <>
      <button
        disabled={expanded}
        onClick={() => setExpanded(true)}
        className="btn btn-primary self-start"
      >
        Update certificate
      </button>
      <span>
        {expanded ? (
          <>
            <textarea
              className="form-control"
              rows={4}
              placeholder="Paste new IdP certificate here (PEM format)"
              value={certValue}
              onChange={(e) => setCertValue(e.target.value)}
            />
            {errorMessage && (
              <div className="text-[#C22426] mt-2">
                <FontAwesomeIcon icon={faExclamationCircle} /> {errorMessage}
              </div>
            )}
            <div className="mt-2">
              <Button
                bare
                onClick={handleSave}
                className="btn btn-primary mr-4"
                disabled={loading || !certValue.trim()}
              >
                Save certificate
              </Button>
              <Button bare onClick={handleCancel} variant="link">
                Cancel
              </Button>
            </div>
          </>
        ) : (
          <>
            Update the IdP certificate for this SAML integration.{" "}
            {expirationInfo}
          </>
        )}
      </span>
    </>
  );
};

export default UpdateCertSaml;
